'use strict';

jQuery(function ($) {
	// Au scroll faire apparaitre ou disparaitre le bouton de retour en haut de page
	$(window).on('scroll', function () {
		var $back = $('.back-to-top');
		var duration = 600;
		var posScroll = $(document).scrollTop();

		if (posScroll >= 550) {
			$back.fadeIn(duration);
		} else {
			$back.fadeOut(duration);
		}
	});

	$('.back-to-top').on('click', function (event) {
		event.preventDefault();
		$('html, body').animate({ scrollTop: 0 }, 500);
	});

	// Filtres
	$('.filtres a').click(function (e) {
		e.preventDefault();
		$(this).addClass('active').siblings().removeClass('active');
		var a = $(this).attr('href');
		a = a.substr(1);
		$('.sets a').each(function () {
			if (!$(this).hasClass(a) && a != 'all') $(this).parent().addClass('hide');else $(this).parent().removeClass('hide');
		});
	});

	// Accordion
	$('.accordion-toggle.collapse.in').removeClass('in').css('height', '');
	$('.accordion-heading').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		var $showed = $('.accordion-body.show');
		$(this).parent().addClass('actif').siblings().removeClass('actif');
		$(this).next('.accordion-body').toggleClass('show').css('height', '');
		if ($(this).parent().index() !== $showed.parent().index()) {
			$showed.toggleClass('show').css('height', '');
			$(this).parent().addClass('actif');
		} else {
			$(this).parent().removeClass('actif');
		}
	});

	// CONTACT FORM
	$('.contact-form #jform_contact_email_copy-lbl').parent().parent().addClass('email-copy');

	// Récupère l'url courante :
	var url = $(location).attr('href');

	// création de la regex, pattern -> récupère tout ce qui se trouve après '#' (= récupère l'ID dasn l'url):
	var patternRegex =  new RegExp('#.*');
	var resultRegex = patternRegex.exec(url);

	// éxécution de la regex :
	if (Array.isArray(resultRegex) === true) {
		// ajout de la classe :
		$(resultRegex[0]).addClass('uk-open');
	}

	// permet de faire remonter la vue sur un accordéon cliqué
	$('body').on('click', '.menu-accordeon', function () {
        // Get the current index
        var $scrollEl = $(this);
        // Scroll to element with timeout to let content show
        setTimeout(function(){
            var $scrolling = UIkit.scroll({ duration: 700, offset: 20 });
            $scrolling.scrollTo($scrollEl);
        }, 320);
    });

  // Regex : ajout de lien sur les numéros téléphone
  var regexDeLaMort = /(((?:t[e,é,è]l|t[e,é,è]l\/fax|t[e,é,è]l[e,é,è]phone|[a,o]u)(?:\s\:\s|\:\s|\s)|(?:<strong>t[e,é,è]l(?:\s\:\s|\s\:|\:|)<\/strong>(?:\s|\:\s|)))(?:\s\:\s|)(\d{6}|(?:\d{2}.){2}\d{2}))/gi;
  $('[itemprop=articleBody], .informations *').each(function () {
    var content = $(this).html();
    var testDeLaMort = RegExp(regexDeLaMort);
    if (testDeLaMort.test(content)) {
      content = content.replace(regexDeLaMort, '$2 <a class="detect-phone" href="tel:+687$3">$3</a>');
      $(this).html(content);
    }
  });

	// download ressources
    $('.formSubmitPhoca').on('click', (e) => {
        e.preventDefault()
        e.currentTarget.parentElement.submit()
    })
});

/**
 * Function to load a param in url
 *
 */
jQuery.urlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  return (results == null)? null : results[1];
}

/**
 * Document ready
 * Let's load
 *
 */
jQuery(document).ready(function($){

  const quizzId = $.urlParam('quizz')
  if ($.isNumeric(quizzId)) {
    var modal = UIkit.modal("#modal-full"+quizzId)
    modal.show();
  }

	// Function to open the tarteaucitron panel
	function openTarteaucitronPanel() {
		tarteaucitron.userInterface.openPanel();
	}

	// Select all elements with the class "cookie" and remove the href attribute
	$(".cookie").removeAttr("href");

	// Add the cursor pointer style to each element with the class "cookie"
	$(".cookie").css("cursor", "pointer");

	// Add an event listener to each element with the class "cookie"
	$(".cookie").click(openTarteaucitronPanel);

});


